module.exports = __webpack_public_path__ + "img/dropdown.99b047e3.svg";